module.exports = __webpack_public_path__ + "static/media/truck-2920533_1920.dad05a54.jpg";